import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import paymentMethodService from '../services/paymentMethodService';
import './AddCorporateProfilePage.css';

const EditPaymentMethodPage = () => {
    const navigate = useNavigate();
    const { ppId, methodId } = useParams();
    const [searchParams] = useSearchParams();
    const ruleId = searchParams.get('ruleId');
    const backUrl = ruleId ? `/apps/payment-porter/${ppId}/rules/${ruleId}` : `/apps/payment-porter/${ppId}`;
    const [form, setForm] = useState(null);
    const [errors, setErrors] = useState({});
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        paymentMethodService.getById(ppId, methodId).then(res => {
            const m = res.data?.method;
            if (m) {
                setForm({
                    code:        m.code        || '',
                    description: m.description || '',
                });
            }
        }).catch(() => setErrors({ submit: 'Failed to load payment method' }));
    }, [ppId, methodId]);

    const set = (field, value) => {
        setForm(f => ({ ...f, [field]: value }));
        setErrors(e => ({ ...e, [field]: undefined }));
    };

    const validate = () => {
        const e = {};
        if (!form.code.trim()) e.code = 'Code is required';
        return e;
    };

    const handleSave = async () => {
        const e = validate();
        if (Object.keys(e).length) { setErrors(e); return; }
        setSaving(true);
        try {
            await paymentMethodService.update(ppId, methodId, {
                code:        form.code.trim(),
                description: form.description || null,
                active:      true,
            });
            navigate(backUrl);
        } catch (err) {
            setErrors({ submit: err.response?.data?.error?.message || 'Failed to save payment method' });
        } finally {
            setSaving(false);
        }
    };

    if (!form) return <div className="acp-page"><div className="acp-card" style={{ color: '#6b7280' }}>Loading...</div></div>;

    return (
        <div className="acp-page">
            <div className="acp-card">
                <div className="acp-card-header">
                    <h1 className="acp-title">Edit Payment Method</h1>
                    <p className="acp-subtitle">Update payment method configuration</p>
                </div>

                <div className="acp-divider" />

                <div className="acp-body">
                    <div className="acp-field">
                        <label className="acp-label">Payment Method Code <span className="acp-required">*</span></label>
                        <input
                            className={`acp-input${errors.code ? ' acp-input-error' : ''}`}
                            type="text"
                            placeholder="e.g., VCC, CA, VI"
                            value={form.code}
                            onChange={e => set('code', e.target.value)}
                            autoFocus
                        />
                        {errors.code && <span className="acp-error-msg">{errors.code}</span>}
                    </div>

                    <div className="acp-field">
                        <label className="acp-label">Description</label>
                        <textarea
                            className="acp-input"
                            rows={4}
                            placeholder="Describe the payment method and its use cases"
                            value={form.description}
                            onChange={e => set('description', e.target.value)}
                            style={{ resize: 'vertical' }}
                        />
                    </div>
                </div>

                {errors.submit && <div className="acp-error-msg" style={{ margin: '0 0 1rem' }}>{errors.submit}</div>}
                <div className="acp-footer">
                    <button
                        className="acp-btn-cancel"
                        onClick={() => navigate(backUrl)}
                        disabled={saving}
                    >
                        Cancel
                    </button>
                    <button
                        className="acp-btn-create"
                        onClick={handleSave}
                        disabled={saving}
                    >
                        {saving ? 'Saving...' : 'Save'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default EditPaymentMethodPage;
